import { createContext, Dispatch, SetStateAction } from 'react';

interface ItdrContextProps {
    exclusionDrawerOpen: boolean;
    setExclusionDrawerOpen: Dispatch<SetStateAction<boolean>>;
    showConfiguration: boolean;
    setShowConfiguration: Dispatch<SetStateAction<boolean>>;
    lastActivityDiffInDays?: number;
    setLastActivityDiffInDays: Dispatch<SetStateAction<number>>;
    selectedSeverities?: number[];
    setSelectedSeverities: Dispatch<SetStateAction<number[] | undefined>>;
    selectedStatuses?: number[];
    setSelectedStatuses: Dispatch<SetStateAction<number[] | undefined>>;
    hiddenTypes?: number[];
    graphRefreshToken?: number;
    refreshGraph: () => void;
}

const DEFAULT_STATE_DATA: ItdrContextProps = {
    exclusionDrawerOpen: false,
    setExclusionDrawerOpen: () => {},
    showConfiguration: false,
    setShowConfiguration: () => {},
    setLastActivityDiffInDays: () => {},
    setSelectedSeverities: () => {},
    setSelectedStatuses: () => {},
    hiddenTypes: [],
    graphRefreshToken: 0,
    refreshGraph: () => {}
};

const ItdrContext = createContext<ItdrContextProps>(DEFAULT_STATE_DATA);

export default ItdrContext;
